export default {
  "csvDownload.title": "Export",
};
